import { registerLicense } from '@syncfusion/ej2-base';

// this function is not meant to be a long-term solution, but it's the easiest and least-risky way of allowing our app and all storybook components to easily
// use the same syncfusion license key. see comments in `CommentRichTextEditor.stories.tsx` for more context
export const registerDefaultSyncfusionLicense = () => {
    registerLicense('Ngo9BigBOggjHTQxAR8/V1NBaF5cXmZCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWXtcdnVVRWlYUE1+XUo=');
};
